import { render } from "./AbilityDisplay.vue?vue&type=template&id=b66ce78e&scoped=true"
import script from "./AbilityDisplay.vue?vue&type=script&lang=js"
export * from "./AbilityDisplay.vue?vue&type=script&lang=js"

import "./AbilityDisplay.vue?vue&type=style&index=0&id=b66ce78e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66ce78e"]])

export default __exports__